import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import config from 'config';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import EditIcon from '@material-ui/icons/Edit';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import NoteAddIcon from '@material-ui/icons/NoteAdd';

import OptionsBar from './OptionsBar';
import CreateCsvFile from './CreateCsvFile';
import './TableStyle.css';
import CardHeader from "../../modules/Card/CardHeader.jsx";
import moment from "moment";
import { connect } from 'react-redux';
import { compose } from "recompose";
import papa from 'papaparse';

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    button: {
        margin: theme.spacing.unit,
    },
    searchField: {
        width: '100px'
    }
});

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
    // { id: 'id', numeric: false, disablePadding: false, label: 'Task ID' },
    { id: 'TaskName', numeric: false, disablePadding: false, label: 'Task Name' },
    { id: 'TaskNotes', numeric: false, disablePadding: false, label: 'Task Notes' },
    { id: 'AssignedToName', numeric: false, disablePadding: false, label: 'Assigned To User' },
    { id: 'OwnerName', numeric: false, disablePadding: false, label: 'Owner Name' },
    { id: 'ProjectName', numeric: false, disablePadding: false, label: 'Project' },
    { id: 'Status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'StartDate', numeric: false, disablePadding: false, label: 'Start Date' },
    { id: 'EndDate', numeric: false, disablePadding: false, label: 'End Date' },
    { id: 'Duration', numeric: false, disablePadding: false, label: 'Man-Day' },
    { id: 'TotalManday', numeric: false, disablePadding: false, label: 'Actual Man-Day' },
];

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy } = this.props;
        // onSelectAllClick, numSelected, rowCount

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        {/* <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        /> */}
                    </TableCell>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                    style={{ width: '1px' }}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes, handleDeleteClick, handleCreateTimesheetClick, handleSearchChange, handleOpen, _handleFileChange, data, Pagename } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                        <CardHeader color="success">
                            <div style={{ height: '5vh' }}>Tasks / Issues</div>
                        </CardHeader>
                    )}
            </div>
            <Tooltip title="Create Task or Issue">
                <IconButton aria-label="Create Task or Issue">
                    <AddIcon onClick={handleOpen} />
                </IconButton>
            </Tooltip>

            {
                Pagename !== 'Project' ?
                    <Tooltip title="Upload CSV">
                        <IconButton aria-label="Upload CSV" onClick={() => this.fileUpload.click()}>
                            <CloudUploadIcon />
                        </IconButton>
                    </Tooltip>
                    : null
            }

            {
                Pagename !== 'Project' ?
                    <Tooltip title="Download CSV template">
                        <IconButton aria-label="Download CSV template" onClick={(e) => {
                            window.open(`${config.ApplicationS3BucketEndpoint}/Tasks_upload_template.csv`)
                        }
                        }>
                            <AttachFileIcon />
                        </IconButton>
                    </Tooltip>
                    : null
            }

            <input
                accept=".csv"
                style={{ display: 'none' }}
                id="outlined-button-file"
                type="file"
                onChange={(e) => _handleFileChange(e)}
                onClick={(event) => {
                    event.target.value = null
                }}
                ref={(fileUpload) => {
                    this.fileUpload = fileUpload;
                }}
            />

            <div className={classes.spacer} />
            <div className={classes.actions}>
                {
                    numSelected === 1 ? (
                        <Tooltip title="Create Timesheet">
                            <IconButton aria-label="Create">
                                <NoteAddIcon onClick={handleCreateTimesheetClick} />
                            </IconButton>
                        </Tooltip>
                    ) : null
                }
            </div>
            <div className={classes.actions}>
                {
                    numSelected > 0 ? (
                        <Tooltip title="Delete">
                            <IconButton aria-label="Delete">
                                <DeleteIcon onClick={handleDeleteClick} />
                            </IconButton>
                        </Tooltip>
                    ) : null
                }
            </div>

            <CreateCsvFile data={data} />

            <TextField
                label="Search"
                style={{ width: '80vh' }}
                margin="normal"
                placeholder="Search"
                variant="outlined"
                onChange={handleSearchChange()}
            />
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

class EnhancedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'desc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            searchStr: '',
            value: 3
        };

        this.handleCreateTimesheetClick = this.handleCreateTimesheetClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this._handleFileChange = this._handleFileChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tasksissues.items !== this.props.tasksissues.items)
            this.setState({
                data: nextProps.tasksissues.items,
                selected: []
            });
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleDeleteClick() {
        this.props.handleDeleteTable(this.state.selected)
    }

    handleCreateTimesheetClick() {
        this.props.handleCreateTimesheetClick(this.state.selected)
    }

    handleSearchChange = name => event => {
        this.setState({
            searchStr: event.target.value
        })
    };

    handleClick = (event, n) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(n.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, n.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        if (event === 'check') {
            this.setState({ selected: newSelected });
        }
        else if (event === 'edit') {
            this.props.handleEditTable(n);
        }
        else if (event === 'detail') {
            this.props.handleReadOnlyTable(n);
        }
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    _handleFileChange(e) {
        e.preventDefault();

        let reader = new FileReader()
        let file = e.target.files[0];

        if (file != null) {
            reader.readAsText(file)
        }

        reader.onloadend = () => {
            const csv = reader.result;
            const parseData = papa.parse(csv, {});

            this.props.handleCsvUpload(parseData.data)
        }
    }

    handleOpen = () => {
        this.props.handleOpen()
    };

    handleTabsChange = (value) => {
        this.setState({ value })
    }

    render() {
        const { classes } = this.props;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;

        var data = this.props.Pagename === 'Project'
            ? convert(findSearchStr(projectFilter(this.state.data, this.props.ProjectId), this.state.searchStr))
            : convert(findSearchStr(taskDataProcessing(this.state.data, this.state.value, this.props.user.id, this.props.user.departmentId), this.state.searchStr))

        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        const checkedDarkTheme = this.props.cookies.get('checkedDarkTheme') === 'true' ? true : false || false

        return (
            <Paper className={classes.root}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    handleCreateTimesheetClick={this.handleCreateTimesheetClick}
                    handleDeleteClick={this.handleDeleteClick}
                    handleSearchChange={this.handleSearchChange}
                    handleOpen={this.handleOpen}
                    _handleFileChange={this._handleFileChange}
                    data={data}
                    Pagename={this.props.Pagename}
                />

                {
                    this.props.Pagename !== 'Project'
                        ? <OptionsBar handleTabsChange={this.handleTabsChange} />
                        : null
                }

                <div className={classes.tableWrapper}>
                    <Table id="TaskTable" className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                        />
                        <TableBody>
                            {stableSort(data, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            style={{
                                                background:
                                                    !checkedDarkTheme ?
                                                        n.TaskType === 'Issue' ? '#ffdbe7c4' : n.TaskType === 'PreTask' ? '#d4f1f5' : '' :
                                                        n.TaskType === 'Issue' ? '#e4427bd4' : n.TaskType === 'PreTask' ? '#376c73' : ''
                                            }}
                                            hover
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                {this.props.OwnerUserId === n.OwnerId || this.props.OwnerUserId === n.AssignedToId
                                                    ?
                                                    <div>
                                                        <Checkbox checked={isSelected} onClick={event => this.handleClick('check', n)} />
                                                        <IconButton color={checkedDarkTheme && (n.TaskType === 'Issue' || n.TaskType === 'PreTask') ? 'default' : 'secondary'} aria-label="Edit" className={styles.button} onClick={event => this.handleClick('edit', n)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </div>
                                                    :
                                                    <IconButton color="secondary" aria-label="Edit" className={styles.button} onClick={event => this.handleClick('detail', n)}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                }
                                            </TableCell>
                                            <TableCell>{n.TaskName.length > 20 ? <Tooltip title={n.TaskName}><div>{n.TaskName.substring(0, 20) + ' ...'}</div></Tooltip> : n.TaskName}</TableCell>
                                            <TableCell>{n.TaskNotes.length > 30 ? <Tooltip title={n.TaskNotes}><div>{n.TaskNotes.substring(0, 30) + ' ...'}</div></Tooltip> : n.TaskNotes}</TableCell>
                                            <TableCell>{n.AssignedToName}</TableCell>
                                            <TableCell>{n.OwnerName}</TableCell>
                                            <TableCell>{n.ProjectName}</TableCell>
                                            <TableCell>
                                                {n.Status === 1 ? <abbr title="Pending"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'red' }} /></abbr> : null}
                                                {n.Status === 2 ? <abbr title="In-progress"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'yellow' }} /></abbr> : null}
                                                {n.Status === 3 ? <abbr title="Completed"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'green' }} /></abbr> : null}
                                                {n.Status === 4 ? <abbr title="Cancelled"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'grey' }} /></abbr> : null}
                                            </TableCell>
                                            <TableCell>{n.StartDate}</TableCell>
                                            <TableCell>{n.EndDate}</TableCell>
                                            <TableCell>{n.Duration}</TableCell>
                                            <TableCell>{n.TotalManday}</TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

function taskDataProcessing(data, value, UserId, DepartmentId) {
    const taskData = data ? data.filter(function (element) {
        switch (value) {
            //Team Tasks
            case 0:
                if (element.DepartmentId === DepartmentId) {
                    return true
                }
                break;

            //My Tasks
            case 1:
                if (element.TaskType !== 'Issue' && (element.AssignedToId === UserId)) {
                    return true
                }
                break;

            //My Issue
            case 2:
                if (element.TaskType === 'Issue' && (element.AssignedToId === UserId)) {
                    return true
                }
                break;

            //My Pending and In-Progress Tasks
            case 3:
                if (element.AssignedToId === UserId || element.OwnerId === UserId) {
                    if (element.Status !== 3 && element.Status !== 4) {
                        return true
                    }
                }
                break;

            //Assigned to others
            case 4:
                if (element.AssignedToId !== UserId && element.OwnerId === UserId) {
                    return true
                }
                break;
            default:
                return false
        }

        return false
    }) : [];

    return taskData
}

function projectFilter(data, ProjectId) {
    const taskData = data ? data.filter(function (element) {
        if (element.ProjectId === Number(ProjectId)) {
            return true
        }
        return false
    }) : [];

    return taskData
}

function convert(data) {
    let TasksIssuesData = data.map((TasksIssues, key) => {
        return {
            id: TasksIssues.TaskId,
            TaskId: TasksIssues.TaskId,
            TaskType: TasksIssues.TaskType,
            TaskName: TasksIssues.TaskName,
            TaskNotes: TasksIssues.TaskNotes,
            OwnerId: TasksIssues.OwnerId,
            AssignedToId: TasksIssues.AssignedToId,
            ProjectId: TasksIssues.ProjectId,
            Status: TasksIssues.Status,
            StartDate: moment(TasksIssues.StartDate).format(formatter1),
            EndDate: moment(TasksIssues.EndDate).format(formatter1),
            Duration: TasksIssues.Duration,
            CreatedUserId: TasksIssues.CreatedUserId,
            CreatedTime: moment(TasksIssues.CreatedTime).format(formatter1),
            AssignedToName: TasksIssues.AssignedToName,
            OwnerName: TasksIssues.OwnerName,
            ProjectName: TasksIssues.ProjectName,
            TotalManday: (TasksIssues.TotalManHours / 8).toFixed(3),
        };
    });

    return TasksIssuesData;
}

function findSearchStr(data, searchStr) {
    var filterEmpty = data.filter(function (item) {
        if (searchStr === 0 || searchStr === '') {
            return true
        }
        else {
            const TaskName = item.TaskName ? item.TaskName : '';
            const TaskNotes = item.TaskNotes ? item.TaskNotes : '';
            const ProjectName = item.ProjectName ? item.ProjectName : '';

            for (let i = 0; i < TaskName.length; i++) {
                if (TaskName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                    return true
                }
            }

            for (let i = 0; i < TaskNotes.length; i++) {
                if (TaskNotes.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                    return true
                }
            }

            for (let i = 0; i < ProjectName.length; i++) {
                if (ProjectName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                    return true
                }
            }

            return false
        }
    })

    return filterEmpty
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues } = state;

    return {
        user,
        users,
        projects,
        tasksissues
    };
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(withCookies(EnhancedTable));


// WEBPACK FOOTER //
// ./src/components/TasksIssues/EnhancedTable.js